<div class="page-cont col-12">
  <div class="title-cont">
    <h4 class="title-h4-blue">{{ title }}</h4>
  </div>
  <hr />
  <div class="select-cont">
    <label>Tipo de documento</label>
    <select
      class="input-field"
      [(ngModel)]="tipoDocumentoSeleccionado"
      (change)="cambiarTipoDocumento()"
    >
      <option value="docCondition">Condiciones</option>
      <option value="docInstructive">Instructivos</option>
      <option value="docForm">Formularios</option>
      <option value="docProduct">Productos</option>
      <option value="docRequirement">Requisitos</option>
    </select>
  </div>
</div>

<div class="page-cont col-12">
  <div class="documents-list">
    @for (doc of documentosActuales; track doc.description) {
    <div class="document-item">
      <i class="bi bi-file-earmark-arrow-down"></i>
      <a [href]="doc.url" target="_blank">{{ doc.description }}</a>
    </div>
    }
  </div>
</div>
